import { render } from "./localesComponent.vue?vue&type=template&id=48feacb4&scoped=true&ts=true"
import script from "./localesComponent.vue?vue&type=script&lang=ts"
export * from "./localesComponent.vue?vue&type=script&lang=ts"

import "./localesComponent.vue?vue&type=style&index=0&id=48feacb4&scoped=true&lang=scss"

import exportComponent from "D:\\J\\workspace\\FusionServer\\QUA\\Manitou.FusionServer.Web.DiagPortalFront\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48feacb4"]])

export default __exports__